import { useEffect } from 'react';
import { useAppDispatch } from 'store/hooks';
import AddVideo from './AddVideo';
import VideoList from './VideoList';
import { fetchYoutubeURLMetadata } from 'store/reducer/cache/extra';
import { updateIsYouTubeURLMetadataUpdating } from 'store/reducer/cache/slice';
import { useAppSelectorShallow } from 'store/hooks';
import { moreOptionModalVideoURLsSelector } from 'store/reducer/modal/more-options.modal.selectors';
import { isVimeoURL, isYoutubeURL } from 'utils/validators';

const VideosTab: React.FC = () => {
  const dispatch = useAppDispatch();
  const { video_urls, videos_metadata } = useAppSelectorShallow(
    moreOptionModalVideoURLsSelector
  );
  useEffect(() => {
    const urlsWithoutMetadata = video_urls.filter((url) => {
      if (!isYoutubeURL(url) && !isVimeoURL(url)) return false;
      return !videos_metadata.find((meta) => meta.video_url === url);
    });

    if (urlsWithoutMetadata.length > 0) {
      dispatch(updateIsYouTubeURLMetadataUpdating(true));
      dispatch(fetchYoutubeURLMetadata(urlsWithoutMetadata));
    }
    // Re-fetch when URL count changes only; same-length edits are handled elsewhere.
    // eslint-disable-next-line react-hooks/exhaustive-deps -- video_urls.length is the intentional trigger
  }, [video_urls.length, dispatch]);

  return (
    <div className='w-full flex flex-col ~gap-6/8'>
      <AddVideo />
      <VideoList />
    </div>
  );
};

export default VideosTab;
